var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t('courseDataySync.title'),"placement":"top"}},[_c('div',{staticClass:"data_up",staticStyle:{"z-index":"1"},on:{"click":_vm.courseBlock}},[_c('i',{staticClass:"icon-18",class:{warmfont:_vm.isshow && _vm.computedIsshow}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }